import { Component, OnInit ,Inject} from '@angular/core';
import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { VoucherService } from "../../../../accounts/voucher/shared/voucher.service";
import { PrintledgerService } from "../../print/printledger.service";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LedgerService } from "../../../../master/ledger/shared/ledger.service";
import { FormControl } from '@angular/forms';
import { debounceTime } from "rxjs/operators";

@Component({
  selector: 'app-rptledgerpopup',
  templateUrl: './rptledgerpopup.component.html',
  styleUrls: ['./rptledgerpopup.component.css']
})
export class RptledgerpopupComponent implements OnInit {

  BranchList: any[] = [];
  VoucherTypeList: any[] = [];
  LedgerList: any = [];
  searchTerm: FormControl = new FormControl();
  
  constructor(private commonmastersService: CommonmastersService,
    private printledgerService: PrintledgerService,
    private ledgerService: LedgerService,
    private voucherService: VoucherService ,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RptledgerpopupComponent>,) { }

  ngOnInit() {
    this.searchTerm.valueChanges.pipe(debounceTime(700)).subscribe(
      term => {
        if (term != '') {
          this.ledgerService.FetchLedgerByNames(term).subscribe(
            data => {
              
              this.LedgerList = data as any[];
            }
          )
        }
      })

    this.GetBranchList();
    this.data.BranchId = 0;
  }

  GetBranchList() {
    this.commonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;
       
    })
  }

  GenerateReports(): void {
    if(this.data.LedgerId!=undefined)
      this.data.LedgerId = this.LedgerList.find(item => item.SubLedgerName == this.data.LedgerId).Id;
    else
      this.data.LedgerId = 0;

    this.data.ReportName = "LedgerReport";    
    this.printledgerService.GenerateReport(this.data);
    this.dialogRef.close();
  }

}
